module.exports = __webpack_public_path__ + "img/view.3449f32a.png";